<template>
  <div class="ape-button">
    <el-popover
      v-if="userPermissions.indexOf(permission) != -1"
      :ref="'del-el-popover-'+index"
      placement="top"
      :width="popoverWidth">
      <p>{{popoverText}}</p>
      <div style="text-align: right; margin: 0;">
        <el-button type="text" size="mini" @click="$refs['del-el-popover-'+index].doClose()">取消</el-button>
        <el-button type="danger" size="mini" @click="clickConfirm()">确定</el-button>
      </div>
      <ApeButton slot="reference" name="删除" type="danger" size="mini" icon="el-icon-delete" :permission="permission"></ApeButton>
    </el-popover>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import ApeButton from '@/components/ApeButton' 
import { mapGetters } from 'vuex'

export default {
  components: {
    ApeButton
  },
  // 属性
  props:{
    // 下标
    index:{
      type: Number,
      default: 11
    },
    // 宽度
    popoverWidth:{
      type: Number,
      default: 150
    },
    // 提示文字
    popoverText:{
      type: String,
      default: '确定要删除记录吗？'
    },
    // 按钮标识
    permission:{
      type: String,
      default: ''
    }
  },
  // 定义属性
  data() {
    return {
      
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters(['userPermissions'])
  },
  // 方法集合
  methods: {
    clickConfirm() {
      this.$emit('click')
    }
  }
}
</script>

<style lang='stylus'>
  .ape-button
    display inline-block 
</style>